import {DateUtils} from "../_commons/date-utils";

export class Alarm {
  public topologyId: string;
  public dsoInternalId: string;
  public gridElementId: number
  public timestamp: string;
  public violationLoad:string;
  public violationType: string;
  public violationVoltage_V:string;
  public measurementCount:number;
  public deviceId:string;
  public probability:string;
  constructor( topologyId: string,dsoInternalId: string, gridElementId:number, timestamp: string,violationLoad:string, violationType: string,  violationVoltage_V:string, measurementCount: number,deviceId:string,probability:string) {
    this.topologyId = topologyId;
    this.dsoInternalId = dsoInternalId;
    this.gridElementId = gridElementId;
    this.timestamp = timestamp;
    this.violationLoad=this.getTwoDecimal(violationType,violationLoad);
    this.violationType = violationType;
    this.violationVoltage_V = this.getTwoDecimal(violationType,violationVoltage_V);
    this.measurementCount = measurementCount;
    this.deviceId = deviceId;
    this.probability = probability;
  }

  getTimestamp() {
    let locale = window.navigator.language;
    return (new Date(this.timestamp)).toLocaleDateString(locale, {
      hour: '2-digit',
      minute:'2-digit',
      second:'2-digit'
    });
  }

  getTwoDecimal(violationType, num) {
    if (num === null || num === undefined) {
      return null;
    }

    if(violationType==="GMON")
      return parseFloat(num.toFixed(1)) + " V";
    else
      return parseFloat(num.toFixed(1)) + " %";

  }
}
